<template>
  <b-overlay
    class="app-content content"
    :class="[$route.meta.contentClass]"
    :show="$store.state.app.shallShowOverlay"
  >
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <div class="content-body">
        <transition
          :name="routerTransition"
          mode="out-in"
        >
          <slot />
        </transition>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  components: {
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth,
    }
  },
}
</script>

<style>

</style>
